// components/Breadcrumbs.tsx
import React from "react";
import { CrumbLink, StyledBreadcrumbs } from "./Breadcrumbs.styled";
interface BreadcrumbItem {
  id: string | null;
  name: string;
}
interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItem[];
  onBreadcrumbClick: (id: string | null) => void;
}
const BreadcrumbsComponent: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  onBreadcrumbClick
}) => {
  return <StyledBreadcrumbs aria-label="breadcrumb" data-sentry-element="StyledBreadcrumbs" data-sentry-component="BreadcrumbsComponent" data-sentry-source-file="index.tsx">
            {breadcrumbs.map(crumb => <CrumbLink key={crumb.id || "root"} onClick={() => onBreadcrumbClick(crumb.id)}>
                    {crumb.name || "Home"}
                </CrumbLink>)}
        </StyledBreadcrumbs>;
};
export default BreadcrumbsComponent;